<template>
<plan :features="computedFeatures">
    <template v-slot:name>{{ name }}</template>
    <template v-slot:price>{{ price }}<span class="text-sm font-extralight">per month</span></template>
    <template v-slot:additionalPrice>{{ additionalPrice }}/mo</template>
    <template v-slot:frequency>
        <div class="bg-primary-lighter rounded-full text-primary inline-flex my-4">
            <button
                class="font-bold py-2 px-4 rounded-full"
                :class="isFrequency('yearly') ? 'bg-primary text-white' : ''"
                @click="setFrequency('yearly')"
            >Yearly</button>
            <button
                class="font-bold py-2 px-4 rounded-full"
                :class="isFrequency('monthly') ? 'bg-primary text-white' : ''"
                @click="setFrequency('monthly')"
            >Monthly</button>
        </div>
    </template>

    <template v-slot:action>
        <picker-button :selected="isCurrent" @click.native="pick">Choose</picker-button>
    </template>
</plan>
</template>

<script>
export default {
    props: {
        id: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: true,
        },
        current: {
            type: String,
            required: false, // it'll be null if the user is not a customer yet (i.e. not subscribed to a plan)
        },
        monthlyPrice: {
            type: Number,
            required: false,
        },
        monthlyAdditionalPrice: {
            type: Number,
            required: false,
        },
        yearlyPrice: {
            type: Number,
            required: false,
        },
        yearlyAdditionalPrice: {
            type: Number,
            required: false,
        },
        features: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            frequency: undefined,
        }
    },
    mounted() {
        this.frequency = this.currentFrequency || 'yearly';
    },
    computed: {
        currentFragments() {
            if (!this.current) return {};

            const lastIndex = this.current.lastIndexOf('-');
            const id        = this.current.substr(0, lastIndex),
                  frequency = this.current.substr(lastIndex + 1);
            
            return {id, frequency};
        },
        currentId() {
            return this.currentFragments['id'];
        },
        currentFrequency() {
            return this.currentFragments['frequency'];
        },
        price() {
            if (this.isFrequency('monthly')) return this.monthlyPrice;
            
            if (this.isFrequency('yearly')) return this.yearlyPrice / 12;
        },
        additionalPrice() {
            if (this.isFrequency('monthly')) return this.monthlyAdditionalPrice;
            
            if (this.isFrequency('yearly')) return this.yearlyAdditionalPrice / 12;
        },
        computedFeatures() {
            return this.features.filter(feature => {
                // show bonuses only in the yearly feature set
                if (feature.type === 'bonus') return this.isFrequency('yearly');

                return true;
            })
        },
        isCurrent() {
            return `${this.currentId}.${this.currentFrequency}` === `${this.id}.${this.frequency}`;
        },
    },
    methods: {
        isFrequency(frequency) {
            return this.frequency === frequency;
        },
        setFrequency(frequency) {
            this.frequency = frequency;
        },
        pick() {
            this.$emit('picked', `${this.id}-${this.frequency}`);
        }
    }
}
</script>